module.exports = __webpack_public_path__ + "img/12Ox6OO.d41d8cd9.svg";